import {SvgIcon} from "@mui/material";
import React from 'react';

export const EditIcon = ({color = '#fff', width = 13, height = 13}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 13 13"
        >
            <path
                fill={color}
                d="M1.333 11.667h.934l5.75-5.75-.934-.934-5.75 5.75v.934zm9.534-6.717l-2.834-2.8.934-.933a1.28 1.28 0 01.941-.384c.373 0 .686.128.942.384l.933.933c.256.256.39.564.4.925.011.361-.11.67-.366.925l-.95.95zm-.967.983L2.833 13H0v-2.833L7.067 3.1 9.9 5.933z"
            ></path>
        </SvgIcon>
    );
}

export const DeleteIcon = ({color = '#fff', width = 14, height = 16}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 16"
            sx={{
                fill: 'none',
                '& path': {
                    stroke: color,
                    width,
                    height,
                }
            }}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M.882 4.412h12.236m-3.06 0V2.118a.765.765 0 00-.764-.765H4.706a.765.765 0 00-.765.765v2.294m1.53 3.059v4.588M8.529 7.47v4.588m3.06 2.294V4.412H2.411v9.94a.765.765 0 00.764.766h7.647a.765.765 0 00.765-.765z"
            ></path>
        </SvgIcon>
    );
}


export const EditPanIcon = ({color = '#d5d5d5', width = 25, height = 25}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 13 13"
            sx={{
                fill: color,
                'button:hover &': {
                    fill: '#1976d2'
                }
            }}
        >
            <path

                d="M1.333 11.667h.934l5.75-5.75-.934-.934-5.75 5.75v.934zm9.534-6.717l-2.834-2.8.934-.933a1.28 1.28 0 01.941-.384c.373 0 .686.128.942.384l.933.933c.256.256.39.564.4.925.011.361-.11.67-.366.925l-.95.95zm-.967.983L2.833 13H0v-2.833L7.067 3.1 9.9 5.933z"
            ></path>
        </SvgIcon>
    );
}

export const StylePanIcon = ({color = '#d5d5d5', width = 25, height = 25}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            sx={{
                fill: color,
                'button:hover &': {
                    fill: '#1976d2'
                }
            }}
        >
            <path
                fillRule="evenodd"
                d="M23.14.93l-.07-.07A2.926 2.926 0 0020.98 0a2.886 2.886 0 00-2.08.86L8.858 10.9a3.04 3.04 0 00-.53.72 7.793 7.793 0 00-4.1 1.621c-.191.144-.36.316-.5.51a6.08 6.08 0 00-.98 1.961c-.25.69-.59 1.631-1.22 3-.42.91-.75 1.541-.98 1.981a3.092 3.092 0 00-.54 1.631c.014.206.08.406.19.58a2.64 2.64 0 002.23 1.07 10.462 10.462 0 008.161-3.371c.378-.44.692-.932.93-1.461a7.882 7.882 0 00.69-3.361.142.142 0 01.02-.04c.325-.144.62-.347.87-.6L23.14 5.1A2.888 2.888 0 0024 3.021 2.927 2.927 0 0023.14.93zM9.7 18.317c-.17.368-.388.711-.65 1.02a8.393 8.393 0 01-6.891 2.6c.05-.1.11-.21.17-.32.24-.46.58-1.11 1.02-2.061a39.058 39.058 0 001.28-3.151c.14-.491.355-.957.64-1.381.062-.08.133-.154.21-.22a5.221 5.221 0 012.59-1.14c.121.537.396 1.027.79 1.411l.07.07c.35.357.788.616 1.27.75a5.614 5.614 0 01-.499 2.422zM21.73 3.691L11.678 13.735a.947.947 0 01-.67.28.983.983 0 01-.67-.28l-.07-.07a.948.948 0 010-1.34L20.309 2.271c.18-.173.42-.27.671-.271a.937.937 0 01.67.27l.08.08c.36.374.36.967 0 1.341z"
            ></path>
        </SvgIcon>
    );
}

export const HelpIcon = ({width = 24, height = 24}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <svg
                ariaHidden="true"
                className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
                data-testid="HelpOutlineIcon"
                viewBox="0 0 24 24"
            >
                <path
                    d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"></path>
            </svg>
        </SvgIcon>
    );
}

export const StylePanSecondaryIcon = ({color = '#d5d5d5', width = 25, height = 25}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
            sx={{
                fill: color,
                'button:hover &': {
                    fill: '#1976d2'
                }
            }}
        >
            <path
                fillRule="evenodd"
                d="M18 18H2V2h12.3l2-2H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V7.7l-2 2zm1.2-18l-7.6 7.6 2.8 2.8L20 4.8V0zM4 15.9c3.1.2 5.9.2 8.2-2 1.1-1.1 1.1-3 0-4.1-.6-.5-1.3-.8-2-.8s-1.4.3-1.9.8C7.2 11 6.6 14.3 4 15.9z"
                clipRule="evenodd"
            ></path>
        </SvgIcon>
    );
}
export const SortIcon = ({color = '#D5D5D5', width = 14, height = 16}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="12"
            fill="none"
            viewBox="0 0 18 12"
            sx={{
                fill: color,
                'button:hover &': {
                    fill: '#1976d2'
                }
            }}
        >
            <path
                d="M0 12v-2h6v2H0zm0-5V5h12v2H0zm0-5V0h18v2H0z"
            ></path>
        </SvgIcon>
    );
}

export const PlusIcon = ({color = '#fff', width = 12, height = 12}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            sx={{
                width,
                height,
                '& path': {
                    fill: color
                },
            }}
        >
            <path
                d="M5.188 6.813H.313V5.188h4.875V.313h1.625v4.875h4.875v1.625H6.811v4.875H5.188V6.811z"
            ></path>
        </SvgIcon>
    );
}

export const LogOutIcon = React.forwardRef(({color = '#fff'}, ref) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 512 512"
            sx={{
                '& g': {
                    stroke: color
                }
            }}
        >
            <g
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
            >
                <path
                    d="M192 176v-40a40 40 0 0140-40h160a40 40 0 0140 40v240a40 40 0 01-40 40H240c-22.09 0-48-17.91-48-40v-40"></path>
                <path d="M288 336l80-80-80-80M80 256h272"></path>
            </g>
        </SvgIcon>
    );
})
export const ClearIcon = ({color = '#fff', sx = {}, onClick = undefined}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            sx={{
                '& .path': {
                    fill: color
                },
                ...sx,
            }}
            onClick={onClick}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
            >
                <circle cx="16" cy="16" r="14" fill="#252a35"></circle>
                <g fill="#fff" transform="rotate(45 16 16)">
                    <path d="M-18 6H-14V26H-18z" transform="rotate(-90)"></path>
                    <path d="M14 6H18V26H14z"></path>
                </g>
            </svg>
        </SvgIcon>
    );
}

export const MinusIcon = ({color = '#fff'}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            sx={{
                '& path': {
                    fill: color
                }
            }}
        >
            <path
                d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
        </SvgIcon>
    );
}

export const FullScreenIconOn = ({color = '#fff'}) => {
    return (
        <SvgIcon
            width={20}
            height={20}
            sx={{
                '& path': {
                    fill: color
                }
            }}
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1920">
            <path
                d="M884.311 1035.689v696.318H675.186v-339.162L147.926 1920 0 1772.074l527.26-527.155H187.889v-209.23H884.31zM1772.116 0l147.926 147.926-527.155 527.155h339.162v209.335h-696.423V187.889h209.335v339.266z"
            ></path>
        </SvgIcon>
    );
}

export const FullScreenIconOff = ({color = '#fff'}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 34 34"
            sx={{
                '& path': {
                    fill: color
                }
            }}
        >
            <path
                d="M28.914 26.086l-8.5-8.5-2.828 2.828 8.5 8.5-3.379 3.379A1 1 0 0023.414 34H33a1 1 0 001-1v-9.586a1 1 0 00-1.707-.707zm-21-21l3.379-3.379A1 1 0 0010.586 0H1a1 1 0 00-1 1v9.586a1 1 0 001.707.707l3.379-3.379 8.5 8.5 2.828-2.828z"
            ></path>
        </SvgIcon>
    );
}

export const SearchIcon = ({color = '#5F5F5F', width = 20, height = 20, disabled = false}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            sx={{
                fill: 'none',
                '& path': {
                    stroke: disabled ? 'rgba(0, 0, 0, 0.12)' : color
                }
            }}
            viewBox="0 0 20 20"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 19l-5.2-5.2M16 8.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
            ></path>
        </SvgIcon>
    );
}

export const BurgerIcon = ({color = 'white'}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            fill="none"
            viewBox="0 0 24 24"
            sx={{stroke: color}}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 7h14M5 12h7m-7 5h14"
            ></path>
        </SvgIcon>
    );
}

export const RefreshIcon = ({color = '#fff', width = 24, height = 24}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            sx={{fill: color}}
            viewBox="0 0 24 24"
        >
            <g>
                <path
                    d="M14.55 22.42c-.33 0-.64-.22-.73-.56-.11-.4.13-.81.54-.92a9.256 9.256 0 006.89-8.95c0-5.1-4.15-9.25-9.25-9.25-4.33 0-7.17 2.53-8.5 4.06h2.94a.755.755 0 010 1.51H2.01c-.05 0-.14-.01-.21-.03a.899.899 0 01-.24-.12c-.09-.06-.16-.14-.21-.23s-.09-.2-.1-.31V3c0-.41.34-.75.75-.75s.75.34.75.75v2.39C4.38 3.64 7.45 1.25 12 1.25c5.93 0 10.75 4.82 10.75 10.75 0 4.88-3.29 9.16-8.01 10.4-.06.01-.13.02-.19.02zM11.29 22.73c-.02 0-.04-.01-.05-.01-1.08-.07-2.14-.31-3.14-.7a.747.747 0 01-.43-.97c.15-.38.6-.57.97-.43.87.34 1.78.54 2.7.61.39.02.7.36.7.76l-.01.04c-.02.39-.35.7-.74.7zm-5.51-2.15c-.17 0-.33-.06-.47-.16-.84-.68-1.58-1.47-2.18-2.35a.73.73 0 01.19-1.04.77.77 0 011.04.18v.01c.01.01.02.03.03.04a9.21 9.21 0 001.86 1.98c.17.14.28.35.28.58 0 .17-.05.34-.16.48-.15.18-.36.28-.59.28zM2.44 15.7c-.33 0-.62-.21-.71-.52-.32-1.03-.48-2.1-.48-3.18v-.01c.01-.41.34-.74.75-.74s.75.34.75.75c0 .94.14 1.86.41 2.73.02.08.03.15.03.23a.747.747 0 01-.75.74z"></path>
            </g>
        </SvgIcon>
    );
}


export const DownloadIcon = () => {
    return (
        <SvgIcon
            sx={{
                width: '20px',
                height: '20px'
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <g fill="#1565c0">
                    <path d="M24 37.1L13 24h22zM20 4h8v4h-8zM20 10h8v4h-8z"></path>
                    <path d="M20 16h8v11h-8zM6 40h36v4H6z"></path>
                </g>
            </svg>
        </SvgIcon>
    );
}


export const MoreHorizIcon = ({color = '#1565c0', fontSize = ''}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            sx={{
                fill: 'none',
                'path': {
                    stroke: color,
                },
                width: '20px',
                height: '20px',
            }}
        >
            <g strokeMiterlimit="10" strokeWidth="1.5">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
                <path
                    d="M12 13a1 1 0 100-2 1 1 0 000 2zm-5 0a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 100-2 1 1 0 000 2z"></path>
            </g>
        </SvgIcon>
    );
}

export const LeftArrowIcon = ({color = '#fff'}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            sx={{
                fill: color,
                'path': {
                    stroke: color,
                    strokeWidth: '0.1px'
                }
            }}
        >
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </SvgIcon>
    );
}

export const RightArrowIcon = ({color = '#fff'}) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            sx={{
                fill: color,
                'path': {
                    stroke: color,
                    strokeWidth: '0.1px'
                }
            }}
        >
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
        </SvgIcon>
    );
}

export const CalendarIcon = () => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 76.01 76.01"
        >
            <path
                strokeLinejoin="round"
                strokeWidth="0.2"
                d="M18.003 57.008V23.003h5v-3a2 2 0 012-2h4.001a2 2 0 012 2v3h14.002v-3a2 2 0 012-2h4.001a2 2 0 012 2v3h5.001v34.005zm3-3h34.005V31.004H21.003zm2-7.001h6.001v5h-6zm8.001 0h6.001v5h-6zm8.001 0h6.001v5h-6zm8.001 0h6.001v5h-6zm-24.003-7.001h6.001v5h-6zm8.001 0h6.001v5h-6zm8.001 0h6.001v5h-6zm8.001 0h6.001v5h-6zm-16.002-7.001h6.001v5h-6zm8.001 0h6.001v5h-6zm8.001 0h6.001v5h-6zm1.5-13.002a1.5 1.5 0 00-1.5 1.5v3a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.501-1.5v-3a1.5 1.5 0 00-1.5-1.5zm-22.002 0a1.5 1.5 0 00-1.5 1.5v3a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5z"
            ></path>
        </SvgIcon>
    );
}

export const DownloadExcelIcon = ({color = '#fff'}) => {
    return (
        <SvgIcon
        sx={{
            width:'20px',
            height:'20px',
        }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="512"
                height="512"
                enableBackground="new 0 0 512 512"
                viewBox="0 0 512 512"
            >
                <g>
                    <path
                        fill="#F1F5F7"
                        d="M479.689 420.493H270.912c-8.23 0-14.91-6.698-14.91-14.953V106.479c0-8.255 6.68-14.952 14.91-14.952h208.777c8.234 0 14.914 6.697 14.914 14.952V405.54c.001 8.255-6.679 14.953-14.914 14.953zm0 0"
                    ></path>
                    <path
                        fill="#46B34C"
                        d="M330.564 181.244h-59.652c-8.23 0-14.91-6.699-14.91-14.954 0-8.253 6.68-14.951 14.91-14.951h59.652c8.23 0 14.91 6.698 14.91 14.951.001 8.255-6.679 14.954-14.91 14.954zm0 0M330.564 241.057h-59.652c-8.23 0-14.91-6.697-14.91-14.956 0-8.247 6.68-14.947 14.91-14.947h59.652c8.23 0 14.91 6.7 14.91 14.947.001 8.258-6.679 14.956-14.91 14.956zm0 0M330.564 300.866h-59.652c-8.23 0-14.91-6.7-14.91-14.949 0-8.255 6.68-14.954 14.91-14.954h59.652c8.23 0 14.91 6.699 14.91 14.954.001 8.249-6.679 14.949-14.91 14.949zm0 0M330.564 360.683h-59.652c-8.23 0-14.91-6.698-14.91-14.953s6.68-14.954 14.91-14.954h59.652c8.23 0 14.91 6.699 14.91 14.954s-6.679 14.953-14.91 14.953zm0 0M420.039 181.244h-29.826c-8.23 0-14.914-6.699-14.914-14.954 0-8.253 6.684-14.951 14.914-14.951h29.826c8.229 0 14.91 6.698 14.91 14.951 0 8.255-6.681 14.954-14.91 14.954zm0 0M420.039 241.057h-29.826c-8.23 0-14.914-6.697-14.914-14.956 0-8.247 6.684-14.947 14.914-14.947h29.826c8.229 0 14.91 6.7 14.91 14.947 0 8.258-6.681 14.956-14.91 14.956zm0 0M420.039 300.866h-29.826c-8.23 0-14.914-6.7-14.914-14.949 0-8.255 6.684-14.954 14.914-14.954h29.826c8.229 0 14.91 6.699 14.91 14.954 0 8.249-6.681 14.949-14.91 14.949zm0 0M420.039 360.683h-29.826c-8.23 0-14.914-6.698-14.914-14.953s6.684-14.954 14.914-14.954h29.826c8.229 0 14.91 6.699 14.91 14.954s-6.681 14.953-14.91 14.953zm0 0"
                    ></path>
                    <path
                        fill="#3CA241"
                        d="M280.428 35.153c-3.404-2.841-7.967-4.069-12.26-3.168L29.566 76.84c-7.068 1.322-12.169 7.481-12.169 14.687v328.966c0 7.177 5.101 13.364 12.169 14.688l238.602 44.856c.893.177 1.818.271 2.744.271 3.459 0 6.828-1.199 9.516-3.445 3.432-2.836 5.393-7.083 5.393-11.512V46.671c-.001-4.458-1.962-8.676-5.393-11.518zm0 0"
                    ></path>
                    <path
                        fill="#FCFCFC"
                        d="M222.479 305.983l-47.16-54.036 47.697-61.486c5.07-6.524 3.871-15.916-2.6-20.996-6.471-5.086-15.838-3.89-20.932 2.597l-44.175 56.943-37.22-42.64c-5.456-6.287-14.883-6.854-21.028-1.407-6.201 5.438-6.83 14.887-1.401 21.08l41.011 47.011-41.577 53.59c-5.072 6.522-3.877 15.916 2.592 20.997 2.746 2.123 6 3.14 9.188 3.14 4.443 0 8.831-1.973 11.779-5.775l38.03-49.045 43.363 49.68a14.791 14.791 0 0011.213 5.141c3.492 0 6.984-1.227 9.82-3.712 6.202-5.438 6.825-14.888 1.4-21.082zm0 0"
                    ></path>
                </g>
            </svg>
        </SvgIcon>
    );
}

export const DownloadPdfIcon = () => {
    return (
        <SvgIcon
            sx={{
                width: '20px',
                height: '20px',
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 128 128"
                viewBox="0 0 128 128"
            >
                <g>
                    <path
                        fill="#FF402F"
                        d="M95.21 80.32c-.07-.51-.48-1.15-.92-1.58-1.26-1.24-4.03-1.89-8.25-1.95-2.86-.03-6.3.22-9.92.73-1.62-.93-3.29-1.95-4.6-3.18-3.53-3.29-6.47-7.86-8.31-12.89.12-.47.22-.88.32-1.3 0 0 1.98-11.28 1.46-15.1-.07-.52-.12-.67-.26-1.08l-.17-.44c-.54-1.25-1.6-2.57-3.26-2.5l-.98-.03h-.02c-1.86 0-3.36.95-3.76 2.36-1.2 4.44.04 11.09 2.29 19.69l-.58 1.4c-1.61 3.94-3.63 7.9-5.41 11.39l-.23.45c-1.88 3.67-3.58 6.79-5.13 9.43l-1.59.84c-.12.06-2.85 1.51-3.49 1.89-5.43 3.25-9.03 6.93-9.63 9.85-.19.94-.05 2.13.92 2.68l1.54.78c.67.33 1.38.5 2.1.5 3.87 0 8.36-4.82 14.55-15.62 7.14-2.32 15.28-4.26 22.41-5.32 5.43 3.05 12.11 5.18 16.33 5.18.75 0 1.4-.07 1.92-.21.81-.22 1.49-.68 1.91-1.3.82-1.23.98-2.93.76-4.67zM36.49 99.33c.7-1.93 3.5-5.75 7.63-9.13.26-.21.9-.81 1.48-1.37-4.32 6.89-7.21 9.63-9.11 10.5zM60.95 43c1.24 0 1.95 3.13 2.01 6.07.06 2.94-.63 5-1.48 6.53-.71-2.26-1.05-5.82-1.05-8.15 0 0-.05-4.45.52-4.45zm-7.3 40.14c.87-1.55 1.77-3.19 2.69-4.92 2.25-4.25 3.67-7.57 4.72-10.3 2.1 3.82 4.72 7.07 7.79 9.67.39.32.8.65 1.22.98-6.25 1.23-11.66 2.74-16.42 4.57zm39.43-.35c-.38.23-1.47.37-2.17.37-2.26 0-5.07-1.03-9-2.72 1.51-.11 2.9-.17 4.14-.17 2.27 0 2.94-.01 5.17.56 2.22.57 2.25 1.72 1.86 1.96z"
                    ></path>
                    <path
                        fill="#FF402F"
                        d="M104 80c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm10.882 16.988l-.113.176-8.232 11.438c-.548.866-1.508 1.398-2.537 1.398s-1.989-.532-2.536-1.397l-8.346-11.614a3.01 3.01 0 01.01-2.994 3.01 3.01 0 012.596-1.494H100V86c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v6.5h4.276c1.065 0 2.061.572 2.596 1.494a3.01 3.01 0 01.01 2.994z"
                    ></path>
                    <path fill="#FF9A30" d="M84 125.95L83.95 126 84 126z"></path>
                    <path fill="#FF9A30" d="M114 77L114 76.95 113.95 77z"></path>
                    <path
                        fill="#FF402F"
                        d="M111.071 44.243L71.757 4.929A9.936 9.936 0 0064.687 2H24c-5.514 0-10 4.486-10 10v104c0 5.514 4.486 10 10 10h59.95l-4-4H24c-3.309 0-6-2.691-6-6V12c0-3.309 2.691-6 6-6h40.687c1.603 0 3.109.624 4.242 1.757l39.314 39.314A6.044 6.044 0 01110 51.313V72.95l4 4V51.313c0-2.67-1.04-5.181-2.929-7.07z"
                    ></path>
                    <path fill="#FFF" d="M113.95 77L114 76.95 110 72.95"></path>
                </g>
            </svg>
        </SvgIcon>
    );
}

export const CogIcon = ({width = 41, height = 41, color}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 512 512"

        >
            <path
                fill={color}
                d="M256 176a80 80 0 1080 80 80.24 80.24 0 00-80-80zm172.72 80a165.53 165.53 0 01-1.64 22.34l48.69 38.12a11.59 11.59 0 012.63 14.78l-46.06 79.52a11.64 11.64 0 01-14.14 4.93l-57.25-23a176.56 176.56 0 01-38.82 22.67l-8.56 60.78a11.93 11.93 0 01-11.51 9.86h-92.12a12 12 0 01-11.51-9.53l-8.56-60.78A169.3 169.3 0 01151.05 393L93.8 416a11.64 11.64 0 01-14.14-4.92L33.6 331.57a11.59 11.59 0 012.63-14.78l48.69-38.12A174.58 174.58 0 0183.28 256a165.53 165.53 0 011.64-22.34l-48.69-38.12a11.59 11.59 0 01-2.63-14.78l46.06-79.52a11.64 11.64 0 0114.14-4.93l57.25 23a176.56 176.56 0 0138.82-22.67l8.56-60.78A11.93 11.93 0 01209.94 26h92.12a12 12 0 0111.51 9.53l8.56 60.78A169.3 169.3 0 01361 119l57.2-23a11.64 11.64 0 0114.14 4.92l46.06 79.52a11.59 11.59 0 01-2.63 14.78l-48.69 38.12a174.58 174.58 0 011.64 22.66z"></path>
        </svg>
    );
}